export default __webpack_public_path__ + "media/images/new_year/hero_1apartments-182d0222b5e0febd9877ffe8019e03c1.png";